import { render, staticRenderFns } from "./SelectAutocomplete.vue?vue&type=template&id=520b1937"
import script from "./SelectAutocomplete.vue?vue&type=script&lang=js"
export * from "./SelectAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports